export default "__VITE_ASSET__ffd7b7db__"